<template>
  <div class="table-grid-wrap">
    <table>
      <colgroup>
        <col style="width: 14%;" />
        <col style="width: 8%;" />
        <col style="width: 13%;" />
        <col style="width: 13%;" />
        <col style="width: 13%;" />
        <col style="width: 13%;" />
        <col style="width: 13%;" />
        <col style="width: 13%;" />
      </colgroup>
      <thead>
        <tr>
          <th>{{ table_column }}</th>
          <th>Grade</th>
          <th>Rapid Accel</th>
          <th>Rapid Decel</th>
          <th>E-Stop</th>
          <th>DoD</th>
          <th>Battery Output (C-RATE)</th>
          <th>Cabin Temp.</th>
        </tr>
      </thead>
      <tbody>
        <tr :key=i :ref="'score_table_' + i" v-for="(score, i) in routesDriverScore" @click="setPopupFlag(score.route_nm, score.bat_grade)">

          <td>{{ score.route_nm }}</td>

          <td>{{ score.bat_grade }}</td>
          
          <td class="accel">
            <div>
              <div class="total">
                <div class="val">
                  {{ score.car_rapid_accel }}
                </div>
                <div class="diff" v-if="score.car_rapid_accel_diff > 0">
                  +{{ score.car_rapid_accel_diff }}
                </div>
                <div class="diff" v-else>
                  {{ score.car_rapid_accel_diff }}
                </div>
              </div>
            </div>
          </td>

          <td class="decel">
            <div>
              <div class="total">
                <div class="val">
                  {{ score.car_rapid_decel }}
                </div>
                <div class="diff" v-if="score.car_rapid_decel_diff > 0">
                  +{{ score.car_rapid_decel_diff }}
                </div>
                <div class="diff" v-else>
                  {{ score.car_rapid_decel_diff }}
                </div>
              </div>
            </div>
          </td>

          <td class="stop">
            <div>
              <div class="total">
                <div class="val">
                  {{ score.car_sudden_stop }}
                </div>
                <div class="diff" v-if="score.car_sudden_stop_diff > 0">
                  +{{ score.car_sudden_stop_diff }}
                </div>
                <div class="diff" v-else>
                  {{ score.car_sudden_stop_diff }}
                </div>
              </div>
            </div>
          </td>

          <td class="dod">
            <div>
              <div class="total">
                <div class="val">
                  {{ score.bat_dod }}
                </div>
                <div class="diff" v-if="score.bat_dod_diff > 0">
                  +{{ score.bat_dod_diff }}
                </div>
                <div class="diff" v-else>
                  {{ score.bat_dod_diff }}
                </div>
              </div>
            </div>
          </td>

          <td class="crate">
            <div>
              <div class="total">
                <div class="val">
                  {{ score.bat_crate }}
                </div>
                <div class="diff" v-if="score.bat_crate_diff > 0">
                  +{{ score.bat_crate_diff }}
                </div>
                <div class="diff" v-else>
                  {{ score.bat_crate_diff }}
                </div>
              </div>
            </div>
          </td>

          <td class="temp">
            <div>
              <div class="total">
                <div class="val">
                  {{ score.car_inside_temperature }}
                </div>
                <div class="diff" v-if="score.car_inside_temperature_diff > 0">
                  +{{ score.car_inside_temperature_diff }}
                </div>
                <div class="diff" v-else>
                  {{ score.car_inside_temperature_diff }}
                </div>
              </div>
            </div>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'GradeStatusTable1',

  data () {
    return {
      routesDriverScore: [],
      routesDriverMaxScore: {
        car_rapid_accel: 0,
        car_rapid_decel: 0,
        car_sudden_stop: 0,
        bat_dod: 0,
        bat_crate: 0,
        car_inside_temperature: 0,
        table_data: ''
      },
      popup_car_number: ''
    }
  },

  props: [
    'route_option',
    'table_column',
    'orderby_option'
  ],

  watch: {
    // routesDriverMaxScore �?변�?감�?
    routesDriverMaxScore: function () {
      for (const e of Object.values(this.$refs)) {
        const el = e[0];

        if (el === undefined) continue;

        const accel = el.querySelector('.accel');
        const decel = el.querySelector('.decel');
        const stop = el.querySelector('.stop');
        const dod = el.querySelector('.dod');
        const crate = el.querySelector('.crate');
        const temp = el.querySelector('.temp');

        [accel, decel, stop, dod, crate, temp].forEach((td, i) => {
          const total = td.querySelector('.total');
          const val = total.querySelector('.val');
          const diff = total.querySelector('.diff');

          const value_max = Object.values(this.routesDriverMaxScore)[i];
          const value_val = Number(val.innerHTML);
          const value_diff = Number(diff.innerHTML);

          if (value_diff < 0) {
            val.style.width = `${100 * value_val / value_max}%`;
            diff.style.width = `${100 * -value_diff / value_max}%`;
          }
          else {
            val.style.width = `${100 * (value_val - value_diff) / value_max}%`;
            diff.style.width = `${100 * value_diff / value_max}%`;
          }
        })
      }
    },

    route_option: function () {
      this.gradestatus_get_table_data();
    },
    
    orderby_option: function(){
      this.gradestatus_get_table_data();
    },
  },

  mounted () {
    this.gradestatus_get_table_data();
  },

  methods: {
    gradestatus_get_table_data (){
      // 테이블 리셋
      this.resetScoreTable();
      
      // 데이터 가져오기
      var post_data = {orderby_option: this.orderby_option, route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/gradestatus_get_table_data', post_data).then(res => {
        this.table_data = res.data.result[0];

        var name = (this.route_option == 0) ? "route_nm" : "car_number";
        for(var i=0;i<this.table_data.length; i++){
          var data_prev = this.table_data[i]['prev'][0];
          var data = this.table_data[i];
          
          var _data_prev = {
            bat_grade: data_prev['bat_grade'],
            car_rapid_accel: data_prev['car_rapid_accel'],
            car_rapid_decel: data_prev['car_rapid_decel'],
            car_sudden_stop: data_prev['car_sudden_stop'],
            bat_dod: data_prev['bat_dod'],
            bat_crate: data_prev['bat_crate'],
            car_inside_temperature: data_prev['car_inside_temperature']
          }

          var _data = {
            route_nm: data[name],
            bat_grade: data['bat_grade'],
            car_rapid_accel: data['car_rapid_accel'],
            car_rapid_decel: data['car_rapid_decel'],
            car_sudden_stop: data['car_sudden_stop'],
            bat_dod: data['bat_dod'],
            bat_crate: data['bat_crate'],
            car_inside_temperature: data['car_inside_temperature']
          }

          this.setRoutesDriver(_data_prev, _data);
        }
      });
    },

    /**********
    * ?�월?��??�선�??�행?�적 값을 ?�정?�는 메소??
    * this.routesDriverScore 배열??값을 추�???
    * @param { array } before_datas ?�전???�이??
    * @param { array } current_datas ?�번???�이??
    **********/
    setRoutesDriverScore (before_datas, current_datas) {
      if (typeof before_datas !== 'object') {
        console.log('CUSTOM TYPE ERROR!!! setRouteDriverScore params1 error!');
        return;
      } else if (typeof current_datas !== 'object') {
        console.log('CUSTOM TYPE ERROR!!! setRouteDriverScore params2 error!');
        return;
      }

      const {
        route_nm,
        bat_grade,
        car_rapid_accel,
        car_rapid_decel,
        car_sudden_stop,
        bat_dod,
        bat_crate,
        car_inside_temperature
      } = current_datas;

      const filterDecimalPoint = this.filterDecimalPoint;
      this.routesDriverScore.push({
        route_nm: route_nm,
        bat_grade: filterDecimalPoint(bat_grade),
        car_rapid_accel: filterDecimalPoint(car_rapid_accel),
        car_rapid_accel_diff: filterDecimalPoint(car_rapid_accel - before_datas.car_rapid_accel),
        car_rapid_decel: filterDecimalPoint(car_rapid_decel),
        car_rapid_decel_diff: filterDecimalPoint(car_rapid_decel - before_datas.car_rapid_decel),
        car_sudden_stop: filterDecimalPoint(car_sudden_stop),
        car_sudden_stop_diff: filterDecimalPoint(car_sudden_stop - before_datas.car_sudden_stop),
        bat_dod: filterDecimalPoint(bat_dod),
        bat_dod_diff: filterDecimalPoint(bat_dod - before_datas.bat_dod),
        bat_crate: filterDecimalPoint(bat_crate),
        bat_crate_diff: filterDecimalPoint(bat_crate - before_datas.bat_crate),
        car_inside_temperature: filterDecimalPoint(car_inside_temperature),
        car_inside_temperature_diff: filterDecimalPoint(car_inside_temperature - before_datas.car_inside_temperature),
      })
    },

    /**********
    * ?�월?��??�선�??�행?�적 박스 max 값을 ?�정
    * @param { array } before_datas ?�전???�이??
    * @param { array } current_datas ?�번???�이??
    **********/
    setRoutesDriverBox (before_datas, current_datas) {
      let newScore = {...this.routesDriverMaxScore};
      const types = [
        'car_rapid_accel',
        'car_rapid_decel',
        'car_sudden_stop',
        'bat_grade',
        'bat_dod',
        'bat_crate',
        'car_inside_temperature'
      ];

      // �?박스 �?최�?�??�정
      for (let i = 0; i < types.length; i++) {
        const type = types[i];
        const newMax = this.filterTheBigNumber(
          before_datas[type],
          current_datas[type]
        ) * 1.2

        if (this.routesDriverMaxScore[type] <= newMax) {
          newScore[type] = newMax
        }
        else {
          newScore[type] = this.routesDriverMaxScore[type]
        }

        this.routesDriverMaxScore = newScore;
      }
    },

    /**********
    * ?�이�?초기??
    **********/
    resetScoreTable () {
      this.routesDriverScore = [];
      this.routesDriverMaxScore = {
        car_rapid_accel: 0,
        car_rapid_decel: 0,
        car_sudden_stop: 0,
        bat_dod: 0,
        bat_grade: 0,
        bat_crate: 0,
        car_inside_temperature: 0
      }
    },

    // ????반환
    filterTheBigNumber (value1, value2) {
      if (value1 >= value2)
        return value1
      else
        return value2
    },

    // ?�수?????�리 ?�까지 반환
    filterDecimalPoint (value, num = 1) {
      return Number(Number(value).toFixed(num))
    },

    async setRoutesDriver (beforeDatas, currentDatas) {
      await this.setRoutesDriverScore(beforeDatas, currentDatas);
      await this.setRoutesDriverBox(beforeDatas, currentDatas);
    },

    // 차량 상세정보 팝업 실행
    setPopupFlag (car_number, bat_grade) {
      if(this.table_column == 'Vehicle No.'){
        this.$emit('setPopupCarNumber', car_number)
        this.$emit('setPopupbatGrade', bat_grade)
        this.$emit('setPopupFlag', true);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-grid-wrap {
  height: 100%;
  border-top: 8px solid #5c5c5c;
  overflow: auto;
  @include mobile {
    border-top: 5px solid #5c5c5c;
  }
  table {
    width: 100%;
    min-width: 1400px;
    @include mobile {
      min-width: 1200px;
    }

    thead {
      position: sticky;
      top: 0;
      left: 0;
      background: #fff;
      th {
        font-size: 20px;
        color: #077f80;
        height: 44px;
        font-weight: 700;
        border-bottom: 1px solid #9e9e9e;
        white-space: nowrap;
        @include mobile {
          font-size: 16px;
          height: 36px;
        }
      }
    }

    tbody {
      margin-top: 46px;
      height: calc(100% - 46px);
      tr {
        width: 100%;
        height: 44px;
        cursor: pointer;
        @include mobile {
          height: 36px;
        }
        &:hover {
          background: #aee3cc;
        }
        td {
          font-size: 20px;
          color: #080000;
          border-bottom: 1px solid #9e9e9e;
          text-align: center;
          font-weight: 600;
          white-space: nowrap;
          @include mobile {
            font-size: 14px;
          }

          >div {
            padding: 0 15px;
            @include mobile {
              padding: 0 10px;
            }
          }
          
          .total {
            width: 175px;
            height: 25px;
            border: 2px solid #999;
            border-radius: 3px;
            display: flex;
            font-size: 15px;
            background: #fff;
            @include mobile {
              width: 150px;
            }

            .val {
              width: 50px;
              height: 100%;
              background: #555;
              text-align: center;
              color: #fff;
            }
            .diff {
              width: 20px;
              height: 100%;
              background: #999;
              text-align: center;
            }
          }

          &.accel {
            .total {
              border-color: #aac9e3;
              .val {
                background-color: #588dc3;
              }
              .diff {
                background-color: #96b9de;
                color: #47729e;
              }
            }
          }

          &.decel {
            .total {
              border-color: #9cbfde;
              .val {
                background-color: #286cb4;
              }
              .diff {
                background-color: #5c9ff7;
                color: #286cb4;
              }
            }
          }

          &.stop {
            .total {
              border-color: #cd7f35;
              .val {
                background-color: #ff9f42;
              }
              .diff {
                background-color: #fddf9c;
                color: #ff9f42;
              }
            }
          }

          &.dod {
            .total {
              border-color: #a5edd9;
              .val {
                background-color: #1dd2a1;
              }
              .diff {
                background-color: #78e4c6;
                color: #16a880;
              }
            }
          }

          &.crate {
            .total {
              border-color: #ccf5eb;
              .val {
                background-color: #0a6750;
              }
              .diff {
                background-color: #15aa83;
                color: #0a6750;
              }
            }
          }

          &.temp {
            .total {
              border-color: #ffe1a2;
              .val {
                background-color: #fecb57;
              }
              .diff {
                background-color: #ffeb99;
                color: #ff9f42;
              }
            }
          }
        }
      }
    }
  }
}
</style>
